class CartModel {
  constructor({ id = null, items = {} } = {}) {
    this.id = id;
    this.items = items;
  }
  json() {
    return {
      id: this.id,
      items: this.items,
    };
  }
  list() {
    let _return = [];
    for (let id in this.items) {
      _return.push(this.items[id]);
    }
    return _return;
  }
}

module.exports = CartModel;
